import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js';
//import {  Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import moment from 'moment'
import {
	BasicSelect
} from 'vue-search-select'
import DatePicker from 'vue2-datepicker'
export default {
	name: 'shipmentdetails',
	components: {
		BasicSelect,
		Paginate,
		VueElementLoading,
		DatePicker,
	},
	props: [],
	data() {
		return {
			shipmentno: '',
			hubzone:'',
			hubzonelist:[],
			hubzoneitem: {
        value: "",
        text: "",
      },
			isZoneLoading:'',
			sourcehublist: [],
			destinationhublist: [],
			sourcehubitem: {
				id: '',
				text: ''
			},
			hubLoading: '',
			sourcehub: '',
			pageCount: 0,
			limit: 10,
			pageNo: 1,
			totalRecords: 0,
			isLoading: false,
			shipmentDetailsList: [],
			username: '',
			useremail: '',
			uasertype: '',
			hubid: '',
			fromdate: '',
			todate: '',
			sourcehubErr: '',
			ImageURLPath: ''
		}
	},
	computed: {

	},
	filters: {
		moment: function(date) {
			if (date == null || date == '')
				return '--'
			return moment(date).format('DD-MM-YYYY HH:mm:ss');
		},
		toFixedNum: function(val) {
			if (val && val > 0) {
				return Number(parseFloat(val).toFixed(2));
			} else {
				return 0;
			}
		},
	},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.uasertype = userdetail[0].utype;
		this.username = userdetail[0].FirstName;
		this.useremail = userdetail[0].email
		this.getHubZoneList();
		var obj = {}

var data = "param1=1&param2=2&s3=3&param5--=6"


var result = data.split("&")
if(result.includes('param')){
obj.push(result)
}
	},
	methods: {
		getHubZoneList() {
      this.isZoneLoading = 'Loading Hub Zone...';
      var i = 0;
			var listHubZoneData = []
      this.input = ({})
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'hubzone/list',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.isZoneLoading = '';
          listHubZoneData = result.data.ResponseData;
          for (i = 0; i < listHubZoneData.length; i++) {
            this.hubzonelist.push({
              value: listHubZoneData[i].hubzoneid,
              text: listHubZoneData[i].hubzonename
            })
          }
        }, error => {
          this.isZoneLoading = '';
          console.error(error)
        })
    },
		selectedHubzone(hubzoneitem){
			this.hubzoneitem = hubzoneitem
			this.hubzone = hubzoneitem.text
			this.sourcehublist = []
			this.sourcehubitem= {
				id: '',
				text: ''
			}
			this.sourcehub = ''
			if(this.hubzone!=''){
				this.getHubList();
			}
		},

		getPaginationData(pageNum) {
			this.pageNo = pageNum
			this.getShipmentList(0)
		},
		getHubList() {
			this.sourcehublist=[]
			this.sourcehubitem={
				id: '',
				text: ''
			}
			this.sourcehub=''
			this.hubLoading = 'Loading Hub...'
			this.input = ({
				hubZoneId: this.hubzoneitem.value
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'hubservicecenter/hub/list',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					this.hubLoading = ''
					this.HubDetails = result.data.ResponseData
					var sourcehublist = []
					for (var i = 0; i < this.HubDetails.length; i++) {
						this.sourcehublist.push({
							"id": this.HubDetails[i].HubID,
							"text": this.HubDetails[i].HubName + '(' + this.HubDetails[i].HubID + ')',
						})
					}
				}, error => {
					console.error(error)
				})
		},

		SelectSourceHub(sourcehubitem) {
			this.sourcehubitem = sourcehubitem
			this.sourcehub = sourcehubitem.text
			this.hubid = sourcehubitem.id
		},
		//for filter schedule list
		dateFormat(date) {
			return moment(date).format('YYYY-MM-DD');
		},
		getShipmentCount(check) {
			this.pageCount = 0,
			this.totalRecords = 0,
			this.shipmentDetailsList = [],
			this.isLoading = true
			axios({
					method: 'GET',
					url: apiUrl.api_url_hubops + 'getShipmentDetailsForChennaiSorterImagesCount?shippingId=' + this.shipmentno.trim() + '&hubId=' + this.hubid +
						'&fromDate=' + this.dateFormat(this.fromdate) + '&toDate=' + this.dateFormat(this.todate),
					headers: {
						'authorization': 'authkey xB84JJ89Hd25'
					}
				})
				.then(result => {
					if (result.data.ResultCode == 100) {
						this.totalRecords = result.data.ResponseData;
						this.getShipmentList(check);
					} else {
						this.isLoading = false
						this.$alertify.error(result.data.ReturnMessage)
					}
				}, error => {
					console.error(error)
					this.isLoading = false;
				})
		},
		getShipmentList(check) {
			this.isLoading = true
			if (check == 1) {
				this.pageNo = 1;
			}
			this.limit = 10;
			axios({
					method: 'GET',
					url: apiUrl.api_url_hubops + 'getShipmentDetailsForChennaiSorterImages?shippingId=' + this.shipmentno.trim() + '&hubId=' + this.hubid +
						'&fromDate=' + this.dateFormat(this.fromdate) + '&toDate=' + this.dateFormat(this.todate) +
						'&pageSize=' + this.limit + '&pageNo=' + this.pageNo,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25'
					}
				})
				.then(result => {
					if (result.data.ResultCode == 100) {
						this.isLoading = false;
						this.shipmentDetailsList = result.data.ResponseData;
						if (this.totalRecords < 11) {
							this.pageCount = 1
						} else {
							this.pageCount = Math.ceil((this.totalRecords) / 10);
						}
					} else {
						this.pageCount = 0
						this.isLoading = false;
						this.shipmentDetailsList = [];
						this.$alertify.error(result.data.ReturnMessage)
					}
				}, error => {
					console.error(error)
					this.isLoading = false;
				})
		},

		downloadImage(data, ind) {
			axios({
					method: 'GET',
					url: apiUrl.api_url_hubops + 'downloadImageForChennaiSorter?Imageurlpath=' + data.Imageurlpath,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25'
					}
				})
				.then(result => {
					if (result.data.ResultCode == 100) {
						this.ImageURLPath = result.data.ReturnMessage;
						// var a = document.createElement('a');
						// a.href = this.ImageURLPath;
						// a.download = this.ImageURLPath;
						// document.body.appendChild(a);
						// a.click();
						// document.body.removeChild(a);
						// document.getElementById('imgid' + data.ShippingID).download = this.ImageURLPath;
						// document.getElementById('imgid' + data.ShippingID).href = this.ImageURLPath;
						$('#pdfid' + data.ShippingID).hide();
						$('#imgid' + data.ShippingID).show();
						$('#shipmentno').hide();
						document.getElementById('imgid' + data.ShippingID).src = this.ImageURLPath;
						var modal = document.getElementById('myModalimg' + data.ShippingID);
						var img = document.getElementById('imgid' + data.ShippingID);
						var modalImg = document.getElementById("img01" + data.ShippingID);
						modal.style.display = "block";
						modalImg.src = this.ImageURLPath;
					} else {
						this.ImageURLPath = '';
						$('#shipmentno').show();
						this.$alertify.error(result.data.ReturnMessage)
					}
				}, error => {
					console.error(error)
				})
		},
		//close uploaded file
		closemodal(id) {
			var modal = document.getElementById(id);
			modal.style.display = "none";
			$('#shipmentno').show();
		},

		resetflt() {
			this.sourcehublist=[]
			this.hubzone=''
			this.hubzoneitem= {
        value: "",
        text: "",
      },
			this.shipmentDetailsList = [],
				this.fromdate = '',
				this.todate = '',
				this.sourcehub = '',
				this.shipmentno = '',
				this.sourcehubitem = {
					id: '',
					text: ''
				},
				this.hubLoading = '',
				this.pageCount = 0,
				this.limit = 10,
				this.pageNo = 1,
				this.totalRecords = 0,
				this.isLoading = false,
				this.fromdate = '',
				this.todate = '',
				this.sourcehubErr = '',
				document.getElementById("shipmentno").value = '';

			this.$validator.reset()
		},
		onSubmitflt: function() {

			var self = this
			this.$validator.validateAll().then((result) => {
				if (this.sourcehub == "") {
					this.sourcehubErr = 'Source Hub Name is required .';
					return false;
				} else if (!result) {
					return false
				} else {
					this.getShipmentCount(1);
				}
			}).catch(() => {
				console.log('errors exist')
			});
		},
	}
}



// WEBPACK FOOTER //
// ./src/views/components/ChennaiSorter/ShipmentDetails/ShipmentDetails.js